var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.776a6.011 6.011 0 0 0-4.81-2.416c-3.326 0-6.023 2.708-6.023 6.056 0 1.289.205 2.48.563 3.586 1.712 5.416 6.988 8.656 9.598 9.544.369.13.975.13 1.344 0 2.61-.888 7.886-4.128 9.598-9.544.357-1.105.563-2.297.563-3.586 0-3.348-2.697-6.056-6.023-6.056-1.96 0-3.716.953-4.81 2.416z",
    fill: "#ED1C24",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon11);
export default __webpack_public_path__ + "static/media/icon-11.4437bb3ba4949496360657dc9247c49b.svg";
export { ForwardRef as ReactComponent };